// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#stawag-comparison-staging-gjuce .helper-text{font-size:95%}#stawag-comparison-staging-gjuce .helper-text p:last-child{margin-bottom:0!important}#stawag-comparison-staging-gjuce .helper-text img{max-width:100%;height:auto;vertical-align:middle;border-radius:4px}", ""]);
// Exports
module.exports = exports;
